import React from 'react';
import { useBook } from '../contexts/BookContext';


export default function ConfirmationModal({ isOpen, onClose, onSaveBasic, onSavePreview, onContinueWithoutSave, title, message, isProcessing = false, operationType = null }) {
  const { currentBook, hasActualSpreads } = useBook();
  console.log('Current book has actual spreads:', hasActualSpreads);
  console.log('Spreads data:', currentBook?.spreads || 'No spreads data available')
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" onClick={onClose} />
    

      <div className="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all max-w-lg w-full mx-4 sm:p-6">
        <div>
          <div className="mt-3 text-center sm:mt-5">
            <h3 className="text-lg leading-6 font-medium text-gray-900">
              {title}
            </h3>
            <div className="mt-2">
              <p className="text-sm text-gray-500">
                {message}
              </p>
            </div>
          </div>
        </div>
        <div className="mt-5 sm:mt-6 space-y-3">
          <button
            type="button"
            disabled={isProcessing}
            className={`w-full inline-flex justify-center items-center gap-2 rounded-md border border-transparent shadow-sm px-4 py-2 text-base font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm transition-colors ${
              isProcessing
                ? 'bg-indigo-400 text-white cursor-not-allowed'
                : 'bg-indigo-600 text-white hover:bg-indigo-700'
            }`}
            onClick={() => {
              console.log('DEBUG: Save With Preview Changes button clicked');
              onSavePreview();
            }}
          >
            {isProcessing && (
              <div className="animate-spin rounded-full h-4 w-4 border-2 border-white border-t-transparent"></div>
            )}
            {isProcessing 
              ? operationType === 'preview'
                ? 'Preview generating...'
                : 'Generating Design...'
              : (hasActualSpreads ? 
                'Save With Preview Changes (will overwrite existing design!)' : 
                'Save With Preview Changes')}
          </button>
          <button
            type="button"
            className="w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm"
            onClick={onClose}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
